export default __webpack_public_path__ + "static/media/property-4.dc9bc003.png";